// extracted by mini-css-extract-plugin
export default {"DailyTab":"DailyTab_DailyTab__GHk-S","shadow":"DailyTab_shadow__UXVIj","left":"DailyTab_left__44xTj","right":"DailyTab_right__dHXWJ"};